export function buildRichText(experiences: any[]): string {
  if (!experiences || experiences.length === 0) {
    return '';
  }
  // Build <li> list
  const listItems = experiences.map(exp => `<li>${exp.isCustomTitle ? exp.customTitle : exp.experience.name}</li>`).join('');
  return `
    <div>
      <ul>
        ${listItems}
      </ul>
    </div>
  `;
}


export function appendRichText(oldRichText: string, newRichText: string): string {
  return `${oldRichText}\n${newRichText}`;
}

export function stripExperienceBlocks(richText: string): string {
  const pattern =
    /(<p\b[^>]*>\s*---\s*<\/p>\s*<p\b[^>]*>\s*Experiences\s+(?:Included|Excluded)\s*<\/p>)[\s\S]*?(<p\b[^>]*>\s*---\s*<\/p>)/gi;



  const cleaned = richText.replace(pattern, "");
  return cleaned.trim();
}
